var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScooter = function SvgScooter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_1260_18806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4983 2.70532L15.6697 7.96247C16.0126 8.70532 15.4412 9.56247 14.6412 9.56247H0.926876V9.44818C1.26973 6.93389 3.38402 4.99104 5.95545 4.99104H7.78402V7.84818H11.6126C12.3554 7.84818 12.9269 7.27675 12.9269 6.53389V2.70532H13.4983Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.64118 4.99114H8.35547C8.35547 4.01971 7.61261 3.27686 6.64118 3.27686H4.35547C3.38404 3.27686 2.64118 4.01971 2.64118 4.99114Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6411 3.27693H15.7839V0.991211H14.6411C14.0125 0.991211 13.4982 1.5055 13.4982 2.13407C13.4982 2.76264 14.0125 3.27693 14.6411 3.27693Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.784 2.13403H13.4983",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.4982 9.56257C13.4982 10.8197 14.5267 11.8483 15.7839 11.8483C17.041 11.8483 18.0696 10.8197 18.0696 9.56257C18.0696 8.30543 17.041 7.27686 15.7839 7.27686",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.06968 9.5625C2.06968 10.8196 3.09826 11.8482 4.3554 11.8482C5.61254 11.8482 6.64111 10.8196 6.64111 9.5625",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_18806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.6411 0.419678)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "scooter.f1afb6cf5b3340604eeff270ce1d5300.svg";